<!--
 * @Description: 转移客户
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2022-12-01 14:00:39
 * @LastEditors: mdb
-->
<template>
  <a-modal v-model:visible="visible" title="转移客户" width="670px" @ok="handleSubmit" :confirmLoading="loading">
    <a-form :model="editForm" ref="formRef" v-if="visible">
      <a-form-item name="seller" label="选择接收人" :rules="[{ required: true, message: '请选择' }]">
        <user-select v-model:value="editForm.seller" :status="1" />
      </a-form-item>
      <a-form-item name="type" label="备注">
        <CosTextarea placeholder="请输入" v-model:value="editForm.remark" :maxlength="2000" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { potentialTransfer } from '@/api/gucangSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
const data = ref<PotentialItem[]>([])
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = defineEmits(['success'])
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { remark, seller, cosIdList } = editForm.value
    potentialTransfer({
      remark,
      cosIdList,
      seller
    })
      .then(() => {
        message.success('转移成功')
        emit('success')
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const toggle = (rows: PotentialItem[]) => {
  if (!rows || !rows.length) {
    message.warning('请选择数据')
    return
  }
  data.value = rows
  const cosIdList = rows.map((item) => item.cosId)
  editForm.value = {
    cosIdList
  }
  visible.value = true
}

defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'transferModel' }
</script>
<style lang="scss" scoped>
.clueMerge {
  .list {
    margin: 20px 0;
    li {
      display: flex;
      align-items: center;
    }
    .name {
      flex: 1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flex1 {
  flex: 1;
}
</style>
